import { Address, parseEther } from 'viem';

import sankoWagerAbi from '@src/abis/SankoWagerAbi';
import dmtABI from '@src/abis/DMTAbi';

export const WALLETCONNECT_PROJECT_ID = 'e72434c1c5e384d881f8c0ee9c62fd3e';

export const RPC_POLLING_INTERVAL = 5_000;

export const DMT_TOTAL_SUPPLY = parseEther(`${1_000_000}`);

export const DMT_ADDR = process.env.REACT_APP_DMT_CONTRACT_ADDRESS as Address;

export const dmtContract = {
  address: DMT_ADDR as Address,
  abi: dmtABI,
};

export const SANKO_WAGER_ADDR = process.env
  .REACT_APP_WAGER_CONTRACT_ADDRESS as Address;

export const sankoWagerContract = {
  address: SANKO_WAGER_ADDR as Address,
  abi: sankoWagerAbi,
};

export const SANKO_DREAM_MACHINE_HOST =
  process.env.REACT_APP_VERCEL_ENV === 'production' ||
  process.env.NODE_ENV === 'production'
    ? 'https://sanko.xyz'
    : 'https://staging.sanko.xyz';
